// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as AllValues from "./AllValues.bs.js";
import * as TeamPhoto from "./TeamPhoto.bs.js";
import * as ValueHeader from "./ValueHeader.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var wrapper = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.white),
      tl: {
        hd: BsCss.margin(BsCss.px(20)),
        tl: /* [] */0
      }
    });

var container = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 768px)", {
            hd: BsCss.display("flex"),
            tl: {
              hd: BsCss.justifyContent("spaceBetween"),
              tl: /* [] */0
            }
          }),
      tl: /* [] */0
    });

var Styles = {
  wrapper: wrapper,
  container: container
};

function OurValueSection(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ValueHeader.make, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TeamPhoto.make, {}),
                        JsxRuntime.jsx(AllValues.make, {})
                      ],
                      className: container
                    })
              ],
              className: wrapper
            });
}

var make = OurValueSection;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
